import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import config from 'config'

import useSnackbar from 'components/organisms/Snackbar/useSnackbar'

// REL-F05 · Downloads the REL-18 segregated Release "situazione" report
// (GET /release/report). Same presigned-URL pattern as useReport/useExport: the
// BE uploads the xlsx to S3 and returns { success, url }; we trigger the browser
// download from that URL. Partner segregation is enforced server-side from the
// JWT — Arval callers get every partner, a partner only its own stock. The file
// round-trips into the REL-11 loader (same 7-column tracciato).
const useReleaseReport = () => {
  const { t } = useTranslation()

  const { showSnackbarMessage } = useSnackbar()

  const [state, setState] = useState({
    isFetching: false,
    error: null,
  })

  const _fetchReleaseReport = async (sessions) => {
    const query = sessions.length
      ? `?sessions=${encodeURIComponent(sessions.join(','))}`
      : ''
    return await axios.get(`${config.apiBaseUrl}release/report${query}`)
  }

  const saveReleaseReport = useCallback(
    async (name, sessions = []) => {
      setState((s) => ({ ...s, isFetching: true, data: null }))

      try {
        const result = await _fetchReleaseReport(sessions)

        if (
          result.data.body.hasOwnProperty('success') &&
          result.data.body.success &&
          result.data.body.hasOwnProperty('url')
        ) {
          const link = document.createElement('a')
          link.setAttribute('href', result.data.body.url)
          link.setAttribute('download', `${name}.xlsx`)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          setState({
            isFetching: false,
            data: { success: result.data.body.success },
            error: null,
          })
        } else {
          setState({ isFetching: false, error: null })
        }
      } catch (e) {
        const message =
          e.response?.data?.message ||
          t('common.error.fetchData', {
            attribute: e.response?.status,
          })

        setState({ isFetching: false, error: e })

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [showSnackbarMessage, t]
  )

  return {
    isFetching: state.isFetching,
    data: state.data,
    error: state.error,
    saveReleaseReport,
  }
}

export default useReleaseReport
